import { useEffect } from 'react';
import type { MoveQualityCounts } from 'endchess-contracts';

export const GAME_ANALYSIS_COMPLETE_EVENT = 'endchess:game-analysis-complete';

export type GameAnalysisCompleteDetail = {
  gameId: string;
  moveQualityCounts?: MoveQualityCounts;
};

export function notifyGameAnalysisComplete(
  detail: GameAnalysisCompleteDetail,
): void {
  window.dispatchEvent(
    new CustomEvent<GameAnalysisCompleteDetail>(GAME_ANALYSIS_COMPLETE_EVENT, {
      detail,
    }),
  );
}

export function useGameAnalysisComplete(
  handler: (detail: GameAnalysisCompleteDetail) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      handler((event as CustomEvent<GameAnalysisCompleteDetail>).detail);
    };

    window.addEventListener(GAME_ANALYSIS_COMPLETE_EVENT, listener);
    return () => window.removeEventListener(GAME_ANALYSIS_COMPLETE_EVENT, listener);
  }, [handler]);
}
